'use client'
import React, { useEffect, useState } from "react";

const LoadingPage = ({ loader }) => {
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      setPageLoaded(true);
    };

    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  if (!loader) {
    return null; // Don't render anything if loader is false
  }

  return (
    <div id="LoadingPage" className={pageLoaded ? "loaded" : ""}>
      <div className="logo-wrapper">
        <img
          className="logo-image"
          src="/images/goat-spins-favicon.svg"
          alt="aaa"
        />
      </div>
    </div>
  );
};

export default LoadingPage;